import type { ICkBreadcrumb } from './ types';

import { Link } from '@chakra-ui/next-js';
import { Breadcrumb as CkBreadcrumb } from '@chakra-ui/react';

import { BreadcrumbItem, BreadcrumbLink, Icon } from '@/components';
import ArrowLeft from '@/svgs/ArrowLeft.svg';

const Breadcrumb: ICkBreadcrumb = ({ list, ...props }) => {
  return (
    <CkBreadcrumb
      separator={<Icon as={ArrowLeft} boxSize="3" mt="1" fill="gray.700" />}
      {...props}
      overflowY="hidden"
      overflowX="scroll"
      listProps={{
        width: 'max-content',
      }}
    >
      {list.map(({ title, href }, index) => {
        const isCurrentPage = index + 1 === list.length;
        return (
          <BreadcrumbItem
            key={href}
            fontSize={{ base: 'xs', md: 'md' }}
            isCurrentPage={isCurrentPage}
          >
            {index + 1 === list.length ? (
              <BreadcrumbLink color="black">{title}</BreadcrumbLink>
            ) : (
              <BreadcrumbLink as={Link} color="gray.700" href={href}>
                {title}
              </BreadcrumbLink>
            )}
          </BreadcrumbItem>
        );
      })}
    </CkBreadcrumb>
  );
};

export default Breadcrumb;
